"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcPaymentInvoices = class UcPaymentInvoices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    createInvoicePaymentData(...args) {
        const [data] = args;
        return {
            invoice_id: data.id,
            invoice_number: data.invoice_number,
            currency: data.currency,
            amount: data.outstanding_amounts,
            exchange_rate: 1,
            client: data.client,
            invoice: data
        };
    }
    payment;
    onPayment(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("payment");
    }
    messages;
    ux;
    b_5962862420439144_paging;
    b_5962862420439144_sortable;
    b_5962862420439144_columns;
    dataMembers = ['messages', 'ux', 'b_5962862420439144_paging', 'b_5962862420439144_sortable', 'b_5962862420439144_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    grossAmount: this.$fn.pgettext("Invoice", "Gross amount"),
                    paidAmount: this.$fn.pgettext("Invoice", "Payments"),
                    noPaymentRequired: this.$fn.pgettext("Invoice", "No payment required"),
                },
                ux: null,
                b_5962862420439144_paging: false,
                b_5962862420439144_sortable: false,
                b_5962862420439144_columns: [{
                        name: "invoice_number",
                        width: "310px",
                        header: this.$fn.pgettext("InvoicePayment", "Invoice"),
                        readonly: true,
                        textAlign: "left",
                        type: "template",
                        value: "<DIV>\n\
  <UcInvoiceBadge :value=\"row.invoice\"></UcInvoiceBadge>\n\
\n\
  <div>\n\
    {{ row.invoice.invoice_date || date }}\n\
  </div>\n\
\n\
  <div>\n\
    <ItpText>{{ globs.grossAmount }}:</ItpText>\n\
    <strong>{{ row.invoice.total_amount | number }} {{ row.invoice.currency }}</strong><br/>\n\
  </div>\n\
\n\
  <div v-if=\"row.invoice.total_payment\">\n\
    <ItpText>{{ globs.paidAmount }}:</ItpText>\n\
    <strong>{{ row.invoice.total_payment | number }} {{ row.invoice.currency }}</strong><br/>\n\
  </div>\n\
  <UcCompanyMiniCard :item=\"row.invoice.client\" no-link></UcCompanyMiniCard>\n\
</DIV>\n\
",
                    },
                    {
                        name: "amount",
                        header: this.$fn.pgettext("InvoicePayment", "Amount"),
                        type: "number",
                        width: "110px",
                        textAlign: "right",
                        required: true,
                    },
                    {
                        name: "exchange_rate",
                        width: "70px",
                        header: this.$fn.pgettext("InvoicePayment", "Exch. Rate"),
                        type: "number",
                        textAlign: "right",
                        required: true,
                        noFooterTotals: true,
                    },
                    {
                        name: "notes",
                        width: "210px",
                        header: this.$fn.pgettext("InvoicePayment", "Notes"),
                    },
                ],
            },
        };
    }
    get invoiceTotals() {
        if (this.loaded) {
            return _.isEmpty(this.payment.invoices && this.payment.invoices.data) ? null : _.chain(this.payment.invoices.data)
                .reduce((sum, v, k) => (sum.add(v.amount), sum), this.$fn.numeral(0))
                .value();
        }
        return null;
    }
    get invoiceTotalsDiff() {
        if (this.loaded) {
            return this.invoiceTotals != null
                ? this.$fn.numeral(this.payment.amount).difference(this.invoiceTotals.value())
                : null;
        }
        return null;
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_3343864469950044_script_7882_getActionArgs_value($event) {
        (console.log($event),
            _.chain($event.data.modalResult.value)
                .map(this.createInvoicePaymentData)
                .filter(p => !_.some(this.payment.invoices.data, { invoice_id: p.invoice_id }))
                .each(p => this.payment.invoices.data.push(p))
                .value());
    }
    async act_3343864469950044_script_7882_getActionArgs($event) {
        return {
            value: () => this.act_3343864469950044_script_7882_getActionArgs_value($event),
        };
    }
    async evh_3343864469950044_close_7881_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_3343864469950044_emit_7884_getActionArgs($event) {
        return {
            event: "recalculate",
        };
    }
    async evh_3343864469950044_close_7883_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_3343864469950044_showModal_7880_getActionArgs($event) {
        return {
            name: "InvoiceBrowser",
            props: {
                size: "full-screen",
                company_id: this.payment.account && this.payment.account.owner.id,
                client_id: this.payment.partner && this.payment.partner.id,
                multiselect: true,
            },
        };
    }
    async evh_3343864469950044_click(event, scope) {
        return await this.actions.evh_3343864469950044_click.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_emit_7886_getActionArgs($event) {
        return {
            event: "recalculate",
            value: $event.data.result,
        };
    }
    async evh_5962862420439144_saveCompleted(event, scope) {
        return await this.actions.evh_5962862420439144_saveCompleted.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_script_7888_getActionArgs_value($event) {
        _.remove(this.payment.invoices.data, { invoice_id: $event.data.row.invoice_id });
    }
    async act_5962862420439144_script_7888_getActionArgs($event) {
        return {
            value: () => this.act_5962862420439144_script_7888_getActionArgs_value($event),
        };
    }
    async evh_5962862420439144_delete(event, scope) {
        return await this.actions.evh_5962862420439144_delete.executeFromDOM(this, event, scope);
    }
    async act_5962862420439144_emit_7890_getActionArgs($event) {
        return {
            event: "recalculate",
        };
    }
    async evh_5962862420439144_deleteCompleted(event, scope) {
        return await this.actions.evh_5962862420439144_deleteCompleted.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_7878 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_7877 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_7878,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_7877],
        });
        const act_3343864469950044_script_7882 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3343864469950044_script_7882_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_close_7881 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_script_7882,
            event: "close",
            when: this.evh_3343864469950044_close_7881_getWhen,
            displayName: "script",
        });
        const act_3343864469950044_emit_7884 = new core_1.actions.EmitAction({
            actionArgs: this.act_3343864469950044_emit_7884_getActionArgs,
            events: [],
        });
        const evh_3343864469950044_close_7883 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_emit_7884,
            event: "close",
            when: this.evh_3343864469950044_close_7883_getWhen,
            displayName: "emit",
        });
        const act_3343864469950044_showModal_7880 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_3343864469950044_showModal_7880_getActionArgs,
            displayName: "addInvoice",
            events: [evh_3343864469950044_close_7881, evh_3343864469950044_close_7883],
        });
        const evh_3343864469950044_click_7879 = new core_1.actions.EventHandlerImpl({
            action: act_3343864469950044_showModal_7880,
            event: "click",
            displayName: "addInvoice",
        });
        const evh_3343864469950044_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3343864469950044_click_7879],
        });
        const act_5962862420439144_emit_7886 = new core_1.actions.EmitAction({
            actionArgs: this.act_5962862420439144_emit_7886_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_saveCompleted_7885 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_emit_7886,
            event: "save-completed",
            displayName: "emit",
        });
        const evh_5962862420439144_saveCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_saveCompleted_7885],
        });
        const act_5962862420439144_script_7888 = new core_1.actions.ScriptAction({
            actionArgs: this.act_5962862420439144_script_7888_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_delete_7887 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_script_7888,
            event: "delete",
            displayName: "script",
        });
        const evh_5962862420439144_delete = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_delete_7887],
        });
        const act_5962862420439144_emit_7890 = new core_1.actions.EmitAction({
            actionArgs: this.act_5962862420439144_emit_7890_getActionArgs,
            events: [],
        });
        const evh_5962862420439144_deleteCompleted_7889 = new core_1.actions.EventHandlerImpl({
            action: act_5962862420439144_emit_7890,
            event: "delete-completed",
            displayName: "emit",
        });
        const evh_5962862420439144_deleteCompleted = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5962862420439144_deleteCompleted_7889],
        });
        return {
            act_7315092382398562_reloadComponentData_7878,
            evh_7315092382398562_reload_7877,
            evh_7315092382398562_reload,
            act_3343864469950044_script_7882,
            evh_3343864469950044_close_7881,
            act_3343864469950044_emit_7884,
            evh_3343864469950044_close_7883,
            act_3343864469950044_showModal_7880,
            evh_3343864469950044_click_7879,
            evh_3343864469950044_click,
            act_5962862420439144_emit_7886,
            evh_5962862420439144_saveCompleted_7885,
            evh_5962862420439144_saveCompleted,
            act_5962862420439144_script_7888,
            evh_5962862420439144_delete_7887,
            evh_5962862420439144_delete,
            act_5962862420439144_emit_7890,
            evh_5962862420439144_deleteCompleted_7889,
            evh_5962862420439144_deleteCompleted,
            addInvoice: act_3343864469950044_showModal_7880,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcPaymentInvoices.prototype, "payment", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('payment'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcPaymentInvoices.prototype, "onPayment", null);
UcPaymentInvoices = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcPaymentInvoices);
exports.default = UcPaymentInvoices;
vue_property_decorator_1.Vue.component("UcPaymentInvoices", UcPaymentInvoices);
